import { render, staticRenderFns } from "./NewVuesticModal.vue?vue&type=template&id=58bdb051&scoped=true"
import script from "./NewVuesticModal.vue?vue&type=script&lang=js"
export * from "./NewVuesticModal.vue?vue&type=script&lang=js"
import style0 from "./NewVuesticModal.vue?vue&type=style&index=0&id=58bdb051&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bdb051",
  null
  
)

export default component.exports